// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__mLy5I","container":"styles_container__26U9l","title":"styles_title__2tSqm","wrapper":"styles_wrapper__2_pMF","answer":"styles_answer__3Xxvz"};